import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/menus/$menuId/")({
  component: MenuRedirectPage,
});

function MenuRedirectPage() {
  const { menuId } = Route.useParams();

  return <Navigate params={{ menuId }} to="/menus/$menuId/categories" />;
}
